export enum HttpStatusCode {
  // Client Error Responses
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  
  // Server Error Responses
  InternalServerError = 500,
  BadGateway = 502,
  ServiceUnavailable = 503,
  GatewayTimeout = 504,
}

export enum ServiceMaintenanceStatusCodes {
  NotFound = HttpStatusCode.NotFound,
  Forbidden = HttpStatusCode.Forbidden,
  InternalServerError = HttpStatusCode.InternalServerError,
  BadGateway = HttpStatusCode.BadGateway,
  ServiceUnavailable = HttpStatusCode.ServiceUnavailable,
}
